import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState } from './user.reducer';

// Feature selector
export const selectUserState = createFeatureSelector<UserState>('user');

// Select current user me response
export const selectCurrentUserMeResponse = createSelector(
  selectUserState,
  (state) => state.currentUserMeResponse
);

// Select user type
export const selectUserType = createSelector(
  selectCurrentUserMeResponse,
  (response) => response?.userType
);

// Select user
export const selectUser = createSelector(
  selectCurrentUserMeResponse,
  (response) => response?.user
);

// Select customer (if customer type)
export const selectCustomerFromUser = createSelector(
  selectCurrentUserMeResponse,
  (response) => response?.customer
);

// Select sales user (if sales type)
export const selectSalesUserFromUser = createSelector(
  selectCurrentUserMeResponse,
  (response) => response?.salesUser
);

// Select roles
export const selectUserRoles = createSelector(
  selectCurrentUserMeResponse,
  (response) => response?.roles || []
);

// Select loading state
export const selectUserLoading = createSelector(
  selectUserState,
  (state) => state.loading
);

// Select error state
export const selectUserError = createSelector(
  selectUserState,
  (state) => state.error
);

// Helper selector - check if user is a customer
export const selectIsCustomer = createSelector(
  selectUserType,
  (userType) => userType === 'customer'
);

// Helper selector - check if user is sales
export const selectIsSales = createSelector(
  selectUserType,
  (userType) => userType === 'sales'
);

// Helper selector - check if user is employee
export const selectIsEmployee = createSelector(
  selectUserType,
  (userType) => userType === 'employee'
);
